import api from '../api/axios';

/** Alguien a quien el sistema conoce solo por su correo: un coguía externo. */
export interface ExternoSinRut {
  id: number;
  nombre: string;
  email: string;
  tiene_cuenta: boolean;
  temas: number;
  procesos: number;
  comisiones: number;
  evaluaciones: number;
}

export interface ResultadoFusion {
  relaciones: { que: string; campo: string; n: number }[];
  total: number;
  correo: string;
  origen: string;
  destino: string;
  descartadas: number;
  publicado: boolean;
}

/** Un coguía externo que todavía es solo texto en uno o más temas. */
export interface CoguiaPendiente {
  email: string;
  /** Las distintas grafías con que lo anotaron. */
  nombres: string[];
  temas: { id: number; titulo: string }[];
  /** Nombre de la persona que ya usa ese correo, si la hay: se enganchará a ella. */
  ya_es: string | null;
}

export interface ExternosData {
  registrados: ExternoSinRut[];
  pendientes: CoguiaPendiente[];
  sin_correo: { id: number; titulo: string; nombre: string }[];
}

/** Solo los números, para el contador de la barra. `pendientes` son correos; `sin_correo`, temas. */
export interface ExternosPendientes {
  pendientes: number;
  sin_correo: number;
}

export const personaService = {
  /** Lo registrado, lo pendiente en texto, y lo que ni siquiera tiene correo. */
  externos: async (): Promise<ExternosData> => {
    const { data } = await api.get<ExternosData>('coordinacion/externos/');
    return data;
  },

  /** Las cuentas sueltas: se pide en cada página, así que no trae la lista. */
  externosPendientes: async (): Promise<ExternosPendientes> => {
    const { data } = await api.get<ExternosPendientes>('coordinacion/externos/pendientes/');
    return data;
  },

  /** Registra al coguía de ese correo y engancha todos sus temas de una. */
  darAcceso: async (
    email: string,
  ): Promise<{ persona: { nombre: string }; creada: boolean; cuenta_creada: boolean; temas: number }> => {
    const { data } = await api.post('coordinacion/externos/registrar/', { email });
    return data;
  },

  /** Sin `commit` es una previsualización y no escribe nada. */
  fusionar: async (id: number, destinoId: number, commit = false): Promise<ResultadoFusion> => {
    const { data } = await api.post<ResultadoFusion>(`coordinacion/externos/${id}/fusionar/`, {
      destino_id: destinoId,
      commit,
    });
    return data;
  },
};
